<app-header></app-header>
<app-body></app-body>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true"></ngx-spinner>
